import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Popconfirm } from "antd";
import { Checkbox, Col } from "components/common";
import {
  callDeleteApiWithAuth,
  callGetApi,
  callGetApiWithAuth,
  callPostApiWithAuth,
} from "utils/api";
const callDeleteApi = (expenseId) => {
  const data = {
    method: "delete",
    expenseId: expenseId,
  };
  callPostApiWithAuth(
    "expense",
    data,
    successDeleteExpenses,
    failDeleteExpenses
  );
};
const successDeleteExpenses = (data) => {
};
const failDeleteExpenses = (err) => {
  console.log(err);
};
export const columns = [
  {
    title: <Checkbox />,
    render: () => (
      <a>
        <Checkbox />
      </a>
    ),
  },
  {
    title: "User ID",
    dataIndex: "user",
  },
  {
    title: "Amount",
    dataIndex: "amount",
  },

  {
    title: "Description",
    dataIndex: "description",
  },
  {
    title: "Paid Out",
    dataIndex: "paidOut",
  },
  {
    title: "Pay Date",
    dataIndex: "payDate",
  },
  {
    title: "Type",
    dataIndex: "type",
  },
  {
    title: "Action",
    dataIndex: "expenseId",
    render: (expenseId) => (
      <div>
        <Popconfirm>
          <EditOutlined onClick={() => console.log(expenseId)} />
        </Popconfirm>
        <Popconfirm
          title="Are you sure you want to delete these Records?"
          onConfirm={() => {
            callDeleteApi(expenseId);
          }}
        >
          <DeleteOutlined onClick={() => console.log(expenseId)} />
        </Popconfirm>
      </div>
    ),
  },
];

export const data = [
  {
    key: "1",
    id: "1",
    amount: "$1200",
    description: "Family Support",
    payDay: "FRI, 12 AUGUST 2022",
    type: "Cash",
  },
  {
    key: "2",
    id: "2",
    amount: "$600",
    description: "Utility Bills",
    payDay: "FRI, 12 AUGUST 2022",
    type: "Cheque",
    paidOut: "All",
  },
  {
    key: "3",
    id: "3",
    amount: "$300",
    description: "Transportation",
    payDay: "FRI, 12 AUGUST 2022",
    type: "Cash",
    paidOut: "All",
  },
  {
    key: "4",
    id: "4",
    amount: "$100",
    description: "Unknown Activities",
    payDay: "FRI, 12 AUGUST 2022",
    type: "Cash",
    paidOut: "All",
  },
];
